import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const UserOrgUserTypes = ['core', 'grow'] as const

export type UserOrgUserType = (typeof UserOrgUserTypes)[number]

export const UserOrgUserTypeSchema: z.ZodType<UserOrgUserType> = z.enum(UserOrgUserTypes, { errorMap })
